export default "__VITE_ASSET__dcdc3e0b__"